import { BuildingCalendarTimeGridView } from './BuildingCalendarTimeGridView'
import { useTranslation } from '../i18n'
import type { BuildingCalendarResponse } from '@hub-wifi/shared'

interface BuildingCalendarDayViewProps {
  /** The selected day (YYYY-MM-DD in the building's timezone). */
  date: string
  /** The day-range calendar payload (already fetched by the parent page). */
  data: BuildingCalendarResponse
  loading?: boolean
}

/**
 * Day-view renderer for the building calendar.
 *
 * Thin wrapper over the shared `BuildingCalendarTimeGridView` with a single
 * day column. All grid logic, adaptive hours, chip rendering, and tooltip
 * behavior carry over from the shared component unchanged.
 */
export function BuildingCalendarDayView({ date, data }: BuildingCalendarDayViewProps) {
  const { t } = useTranslation()
  return (
    <BuildingCalendarTimeGridView
      days={[date]}
      data={data}
      ariaLabel={t('buildingCalendar.dayGridLabel')}
      gridTestId="calendar-day-grid"
    />
  )
}
